module.exports = __webpack_public_path__ + "static/img/enterTable.f960ec82.png";